<template>
  <div
    class="loading-spinner"
    :class="{ large: large, 'extra-large': extraLarge }"
  >
    <svg
      class="animation"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        style="opacity: 20%"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        stroke-width="3"
      ></circle>
      <path
        style="opacity: 65%"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      ></path>
    </svg>
  </div>
</template>

<script lang="ts" setup>
defineProps({
  large: {
    type: Boolean,
    default: false,
  },
  extraLarge: {
    type: Boolean,
    default: false,
  },
});
</script>

<style lang="scss" scoped>
.loading-spinner {
  display: flex;
  justify-content: center;
  align-items: center;

  &.large {
    .animation {
      height: 32px;
      width: 32px;
    }
  }
  &.extra-large {
    .animation {
      height: 56px;
      width: 56px;
    }
  }

  .animation {
    animation: spin 1s linear infinite;
    height: 18px;
    width: 18px;
    color: var(--c-g10) !important;

    @keyframes spin {
      from {
        transform: rotate(0deg);
      }
      to {
        transform: rotate(360deg);
      }
    }

    path {
      fill: var(--c-g10) !important;
    }
  }
}

.light-theme.layout-background {
  .loading-spinner {
    .animation {
      color: var(--c-g500) !important;
      path {
        fill: var(--c-g500) !important;
      }
    }
  }
}
</style>
